import { render, staticRenderFns } from "./CustomerEmailLog.vue?vue&type=template&id=3fc0e845&scoped=true&"
import script from "./CustomerEmailLog.vue?vue&type=script&lang=js&"
export * from "./CustomerEmailLog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEmailLog.vue?vue&type=style&index=0&id=3fc0e845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0e845",
  null
  
)

export default component.exports